import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import {Link}from 'react-router-dom';

import logo from './Mauersberger_Logo.png';
import {Navbar, NavItem, NavDropdown, Nav, MenuItem,Breadcrumb} from 'react-bootstrap';

class Header extends Component {



  render() {


    return (

      <header>
        <Navbar inverse collapseOnSelect fixedTop="true" className="customNavBar">
          <Navbar.Header>
            <Navbar.Brand>
              <LinkContainer to="/">
                <img src={logo}  className="logoNavbar"  alt="" />
              </LinkContainer>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse >
            <Nav>
              <NavItem eventKey={1} href="/">
                Home
              </NavItem>
              <LinkContainer to="/News"><NavItem eventKey={2}>
                News
              </NavItem>
            </LinkContainer><LinkContainer to="/FairsAndDates">
              <NavItem eventKey={2} >
                Messen und Termine
              </NavItem>
            </LinkContainer>
              <NavDropdown eventKey={3} className="menuItemDropdown" title="Produkte" id="basic-nav-dropdown">
                <LinkContainer to="/Suppliers">
                  <MenuItem eventKey={3.1}>Übersicht</MenuItem>
                </LinkContainer>
                  <MenuItem divider />
                <LinkContainer to="/Suppliers/WuF">
                  <MenuItem eventKey={3.3} >Werkzeug und Formenbau</MenuItem>
                </LinkContainer><LinkContainer to="/Suppliers/SuB">
                  <MenuItem eventKey={3.2} >Blechbearbeitung</MenuItem>
                </LinkContainer><LinkContainer to="/Suppliers/Automatisierung">
                  <MenuItem eventKey={3.5} >Automatisierung</MenuItem>
                </LinkContainer><LinkContainer to="/Suppliers/Zubehoer">
                  <MenuItem eventKey={3.6} >Zubehör</MenuItem>
                </LinkContainer>
              </NavDropdown>
              {/* <LinkContainer to="/Highlight">
                <NavItem eventKey={4} className="future-header"  >
                  Graphitday
                </NavItem>
              </LinkContainer> */}
            </Nav>
            <Nav pullRight>
              <NavDropdown eventKey={1} title="Über uns" id="basic-nav-dropdown">
                <LinkContainer to="/WhoWeAre">
                <MenuItem eventKey={1.1} >Wer wir sind</MenuItem>
              </LinkContainer><LinkContainer to="/History">
                <MenuItem eventKey={1.2} >Firmengeschichte</MenuItem>
              </LinkContainer>
              {/* <LinkContainer to="/Referenzen">
                <MenuItem eventKey={1.3} >Referenzen</MenuItem>
              </LinkContainer> */}
                <MenuItem divider />
              <LinkContainer to="/Kontakt">
                <MenuItem eventKey={1.4} >Kontakt</MenuItem>
              </LinkContainer><LinkContainer to="/Impressum">
                <MenuItem eventKey={1.5} >Impressum</MenuItem>
              </LinkContainer><LinkContainer to="/DSGVO">
                <MenuItem eventKey={1.5} >Datenschutz</MenuItem>
              </LinkContainer>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/headerComponents/header.js